import { Button, Grid } from '@material-ui/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { ResponsiveContainer } from 'recharts';
import Golden50 from '../../../reports/ClaimReport/50y_logo.jpg';
import ReportStyle from '../../../reports/ClaimReport/Report.module.css';
import styles from '../../../reports/ClaimReport/Table.module.css';
import CmsfLogo from '../../../reports/ClaimReport/logo.png';
import Mujib100 from '../../../reports/ClaimReport/mujib_100_logo.jpg';

// eifie

const UiOfLedgerReport = ({ data ,inwardDividendType,grandTotal,divTypeFromResponse,tableData}) => {

  
  const params = useParams();
  const pdfRef = useRef();
  const pdfRef2 = useRef();


  const columns = [
    {
      accessorKey: 'id',
      header: 'SL',
      size: 50,
      Cell: ({ row }) => row.index + 1,
     },
    // { accessorKey: "id", header: "ID", size: 50 },
    { accessorKey: "ldgacnot", header: "Ledger No", size: 50 },
    { accessorKey: "investorname", header: "Ledger Name", size: 50 },
    { accessorKey: "boid", header: "BO ID", size: 50 },
    { accessorKey: "folio", header: "Folio", size: 50 },
    { accessorKey: "tdate", header: "Transaction Date", size: 50 },
    { accessorKey: "cr", header: "Cr", size: 50 ,},
    { accessorKey: "dr", header: "Dr", size: 50 ,},
    { accessorKey: "bal", header: "Balance", size: 50 ,},
   
  ];


  // const generatePdf = () => {

  //   const pdf = new jsPDF('p', 'mm', 'a4');
  
  //   html2canvas(pdfRef.current, {
  //     scale:2,
  //     useCORS: true,
  //   }).then(canvas => {
  //     const imgData = canvas.toDataURL('image/png');
  //     pdf.addImage(imgData, 'JPEG', 10, 20, 170, 257); 
  //     pdf.save('Claim_Report.pdf');
  //   });
  // };
  const generatePdf = () => {

    const pdf = new jsPDF('p', 'mm', 'a4'); // Create a new PDF document
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();


  html2canvas(pdfRef.current, {
        scale:2,
        useCORS: true,
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        // pdf.addImage(imgData, 'JPEG', 10, 20, 170, 257); 
        // pdf.save('Claim_Report.pdf');
        const imgWidth = canvas.width;
  const imgHeight = canvas.height;
  const aspectRatio = imgHeight / imgWidth;
  const pdfAspectRatio = pdfHeight / pdfWidth;
  const scaleFactor = pdfWidth / imgWidth;
  let remainingHeight = imgHeight;
  let position = 0;
  while (remainingHeight > 0) {
    // Calculate the current height of the content to be added to the current page
    const currentHeight = Math.min(remainingHeight, pdfHeight / scaleFactor);

    // Add the current portion of the content to the PDF
    pdf.addImage(
      imgData,
      'PNG',
      0,
      position,
      pdfWidth,
      pdfWidth * aspectRatio * (currentHeight / imgHeight),
      undefined,
      'FAST'
    );

    // Reduce the remaining height
    remainingHeight -= currentHeight;
    position = -((imgHeight - remainingHeight) / scaleFactor);

    // Add a new page if there is still remaining content
    // if (remainingHeight > 0) {
    //   pdf.addPage();
    // }
  }
  pdf.save('Ledger_Report.pdf');
  
      });
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF("portrait"); 
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    const companyInfo = {
      name: "Capital Market Stabiliztion Fund",
      address:
        "Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000\nTel: +880241052430, Email: claim@cmsfbd.org",
    };
  
    const reportInfo = {
      title: "Ledger-wise Investor Report",
      //instrument: `The Dividend status of the Investor is as follows:`,
      investorCode: `The Dividend status of the Investor is as follows:`,
      // dateRange: `From`,
    };
  
    // Add company header
    doc.setFontSize(12);
    doc.text(companyInfo.name, 14, 13);
    doc.setFontSize(8);
    doc.text(companyInfo.address, 14, 19);
    doc.setFont("helvetica", "bold");
  
    // Add report title and other info
    doc.setFontSize(8);
    doc.text(reportInfo.title, pageWidth - 14, 15, { align: "right" });
    doc.text(reportInfo.investorCode, 14, 32);
    // doc.text(reportInfo.instrument, 14, 36);
    // doc.text(reportInfo.dateRange, 14, 40);
  
    // Table columns
    const tableColumns = columns.map((column) => column.header);
  
    // Prepare table data for PDF
    const tableDataForPDF = tableData.map((row, index) => {
      return columns.map((column) => {
        if (column.accessorKey === "id") {
          return index + 1;
        }
        if (column.accessorKey === "tdate") {
          const rawDate = row[column.accessorKey];
          const date = new Date(rawDate);
          return date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-"); // Format: '02-Jan-2022'
        }
        
        return row[column.accessorKey];
      });
    });

   // Add "Total" row at the bottom
  const totalRow = columns.map((column) => {
    if (column.accessorKey === "investors_dividend_type") return "Total"; 
    if (column.accessorKey === "netamt") return grandTotal.totalNet.toFixed(2); 
    if (column.accessorKey === "cnetamt") return grandTotal.totalSettleNet.toFixed(2); 
    if (column.header === "Outstanding Cash") return ((grandTotal.totalNet - grandTotal.totalSettleNet).toFixed(2)); 
    if (column.accessorKey === "nshare") return grandTotal.totalShare; 
    if (column.accessorKey === "cnshare") return grandTotal.totalSettleShare; 
    if (column.header === "Outstanding Stock") return (grandTotal.totalShare - grandTotal.totalSettleShare); 

    return ""; 
  });

    tableDataForPDF.push(totalRow); // Append the total row at the bottom
    // Get current date & time
    const currentDateTime = new Date()
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  
    doc.autoTable({
      head: [tableColumns],
      body: tableDataForPDF,
      startY: 43,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1.2,
        lineWidth: 0,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: "#000000",
        halign: "center",
        lineWidth: 0.5,
      },
      bodyStyles: {
        textColor: "#000000",
        halign: "left",
      },
      columnStyles: {
        0: { halign: "left" },
      },
      tableWidth: "auto",

        // Bold "Total" and total quantity
      didParseCell: function (data) {
      const rowIndex = data.row.index;
      const lastRowIndex = tableDataForPDF.length - 1;

      if (rowIndex === lastRowIndex) {
        data.cell.styles.fontStyle = "bold"; // Make "Total" row bold
        data.cell.styles.fontSize = 9; // Increase text size
      }
    },
      didDrawCell: (data) => {
        if (data.section === "body") {
          const doc = data.doc;
          const { cell } = data;
  
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(130, 130, 130);
  
          doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // Top line
          doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height); // Bottom line
        }
      },
      didDrawPage: (data) => {
        // Add Date & Time on the bottom-left corner
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.setTextColor(149, 149, 149);
        doc.text(`Print Date & Time: ${currentDateTime}`, 14, pageHeight - 10);
  
        // Add Page Number on the bottom-right corner
        const pageNumber = `Page ${data.pageNumber}`;
        doc.text(pageNumber, pageWidth - 14, pageHeight - 10, { align: "right" });
      },
    });
  
    // Save the PDF
    doc.save("Ledger_Report.pdf");
  };

  return (
    <ResponsiveContainer width="85%">
    <Grid ref={pdfRef2} className={ReportStyle.form}> 
    {/* Page- 1 */}
    </Grid>

    <Grid ref={pdfRef} className={ReportStyle.form}>

      <Grid className={ReportStyle.headerLogo}>
          <div className={ReportStyle.CmsfLogo}>
        {/* <img className={ReportStyle.Golden50} src={Golden50} alt='CMSF Logo' /> */}
          </div>
          <div className={ReportStyle.CmsfLogo}>
        <img className={ReportStyle.CmsfLogo} src={CmsfLogo} alt='CMSF Logo' />
          </div>
          <div className={ReportStyle.Mujib100}>
        {/* <img className={ReportStyle.Mujib100} src={Mujib100} alt='CMSF Logo' /> */}
          </div>

      </Grid>
      <Grid className={ReportStyle.address}>
        <span>Dhaka Chamber Building(3rd Floor), 65-66 Motijheel C/A, Dhaka-1000</span> <br />
        <span>Tel: +880241052430, Email: claim@cmsfbd.org</span>
      </Grid>

      <h1><strong>Ledger-wise Investor Report</strong></h1>
      
      
      
    
      <h5 className={ReportStyle.GategoryName}> Ledger-wise Investor Report</h5>
      <h5>The {divTypeFromResponse==='Cash'? 'Cash Dividend':'Stock Dividend'} status of the Investor is as follows:</h5>
     
      <Grid className={ReportStyle.GategoryName2}>
      <h1></h1>
      <div>
        <table>
          <thead>
            <tr>
            <th className={styles.td} colSpan={3}>Sl</th>
              <th className={styles.td} colSpan={3}>Ledger No</th>
              <th className={styles.td} colSpan={3}>Ledger Name</th>
              <th className={styles.td} colSpan={3}>BO Id</th>
              <th className={styles.td} colSpan={3}>Folio</th>
              <th className={styles.td} colSpan={3}>Transaction Date</th>
              <th className={styles.td} colSpan={3}>Cr </th>
              <th className={styles.td} colSpan={3}>Dr </th>
              {/* <th className={styles.td} colSpan={3}>{inwardDividendType==='Cash'? 'Balance ':'Balance' } </th> */}
              <th className={styles.td} colSpan={3}>Balance</th>
              


          
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} >
                <td className={styles.td} colSpan={3}>{index+1}</td>
               <td className={styles.td} colSpan={3}>{item.ldgacnot!==null?item.ldgacnot:0}</td>
               <td className={styles.td} colSpan={3}>{item.ldgacnot!==null?item.investorname:0}</td>
               <td className={styles.td} colSpan={3} >{item.boid}</td>
               <td className={styles.td} colSpan={3} >{item.folio}</td>
               <td className={styles.td} colSpan={3}>
                {new Date(item.tdate).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  //hour: "2-digit",
                  //minute: "2-digit",
                  // second: "2-digit",
                  hour12: true, // Change to false for 24-hour format
                }).replace(/ /g, "-")}
              </td>
               <td className={styles.td} colSpan={3} >{item.cr}</td>
               <td className={styles.td} colSpan={3} >{item.dr}</td>
               <td className={styles.td} colSpan={3} >{item.bal}</td>
 
              </tr>
            ))}
            {/* <tr>
           
            <td className={styles.td} colSpan={6} style={{fontSize:'1.3rem', textAlign:'Center',fontWeight:'bold'}}>Total</td>
            <td className={styles.td} colSpan={3} style={{fontSize:'1rem', fontWeight:'bold'}}>{(grandTotal.nst).toFixed(2)}</td>
            <td className={styles.td} colSpan={3} style={{fontSize:'1rem', fontWeight:'bold'}}>{(grandTotal.sett).toFixed(2)}</td>
            <td className={styles.td} colSpan={3} style={{fontSize:'1rem', fontWeight:'bold'}}>{(grandTotal.outs).toFixed(2)}</td>
           
          </tr> */}
          </tbody>
        </table>
      </div>
    </Grid>
    
      {/* <h5 className={ReportStyle.GategoryName}>Claimant Information</h5>
    
    <h1></h1>
    <h1></h1> */}

    {/* <h5 className={ReportStyle.GategoryName}>Dividend Information</h5> */}
    
    <br />
    <br />


    {/* <h5 className={ReportStyle.GategoryName}>Payment Information</h5>
    <div>
      
    </div> */}

      <br />
     

      <Grid className={styles.fileListContainer}>
      
      
    </Grid>

      <Grid className={ReportStyle.msgDiv}>
        {/* <span className={ReportStyle.msg}><i>This is a system generated report.</i></span> */}
      </Grid>

    </Grid>
    
     <Button 
     style={{ margin: '10px', marginTop: '20px' , backgroundColor: '#45CFDD'}}  
     variant="contained" 
     color="default" 
     onClick={handleDownloadPDF}>Download Report</Button>
    </ResponsiveContainer>
  );
};

export default UiOfLedgerReport;
